import Vue from "vue";
import Vuex from "vuex";
import handleLoading from "@/utils/HandleLoading";
import Auth from "./Auth";
import Alert from "./Alert";
import Users from "./Users";
import Company from "./Company";
import ImageProduct from "./ImageProduct";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Auth,
    Alert,
    Users,
    Company,
    ImageProduct,
  },
  plugins: [handleLoading],
});
